import React from 'react';
import { Radio } from 'antd';
import styles from './single_select.module.scss';
import { useAtom } from 'jotai';
import {
  singleSelectResponseAtom,
  careProviderConfiguration,
} from '../../../store';
import styled from 'styled-components';
import { InteractionUserResponses } from 'models/interactions.interface';

interface SingleSelectProps {
  answers: { label: string; value: number }[];
  questionId: number;
  rawAnswers: RawAnswer[];
  disabled: boolean;
  selectedAnswers?: InteractionUserResponses['answers'];
}

interface RawAnswer {
  text: string;
  id: number;
  response?: string;
  weightedValue?: number;
}

interface StyleProps {
  color: string;
}

const RadioGroup = styled(Radio.Group)<StyleProps>`
  .ant-radio-button-wrapper-checked {
    background: ${props => props.color} !important;
  }
`;

const SingleSelect: React.FC<SingleSelectProps> = ({
  answers,
  questionId,
  disabled,
  rawAnswers,
  selectedAnswers,
}) => {
  const [, setSingleSelectResponse] = useAtom(singleSelectResponseAtom);
  const [careProviderStyles] = useAtom(careProviderConfiguration);

  const onChange = ({ target: { value } }: any) => {
    const answerText = answers.find(answer => answer.value === value);
    const rawAnswer = rawAnswers.find(answer => answer.id === value);

    const response: RawAnswer = {
      id: value,
      text: answerText?.label || '',
    };
    if (rawAnswer?.weightedValue) {
      response.weightedValue = rawAnswer.weightedValue;
    }
    if (rawAnswer?.response) {
      response.response = rawAnswer.response;
    }
    setSingleSelectResponse({
      questionId: questionId,
      answers: [response],
    });
  };

  const recordPreselectedOption = ({ target: { checked } }: any) => {
    if (checked) {
      if (!selectedAnswers?.length) return;
      setSingleSelectResponse({ questionId, answers: selectedAnswers });
    }
  };

  return (
    <RadioGroup
      color={careProviderStyles.colorPrimary}
      className={`${styles.radioGroup} radio-group`}
      size="large"
      value={selectedAnswers?.[0]?.id || ''}
      optionType="button"
      buttonStyle="solid"
      onChange={onChange}
      onFocus={recordPreselectedOption}
      disabled={disabled}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'left',
      }}
      data-cy="radio_group"
    >
      {answers.map((answer, index) => {
        return (
          <div key={answer.value} data-cy={`radio_button_${index}`} data-cy-answer-label={answer.label}>
            <Radio.Button
              className={styles.radioButton}
              key={answer.value}
              value={answer.value}
            >
              {answer.label}
            </Radio.Button>
          </div>
        );
      })}
    </RadioGroup>
  );
};

export default SingleSelect;
